import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Label } from 'semantic-ui-react';
import '../captainProfileEdit.css';

const functions = getFunctions();
const getUserDashboardSummaryFn = httpsCallable(functions, 'getUserDashboardSummary');

const ProfileNav = () => {
  const [summary, setSummary] = useState({ newSalesCount: 0, unreadMessagesCount: 0 });
  const currentUser = useSelector(state => state.auth.currentUser);

  useEffect(() => {
    if (!currentUser) return;

    const fetchSummary = async () => {
        try {
            const result = await getUserDashboardSummaryFn();
            if (result.data.success) {
                setSummary(result.data.summary);
            }
        } catch (error) {
            // Silently fail, as this is a non-critical UI enhancement.
            console.error("Could not fetch dashboard summary:", error);
        }
    };

    fetchSummary();
  }, [currentUser]);

  const activeLinkStyle = {
    color: '#39a0ed',
    borderBottom: '2px solid #39a0ed',
    paddingBottom: '5px',
    fontWeight: 'bold',
  };

  return (
    <div className="profileNav-container">
      <div className="profileNav-align">
        <div className="profileNav-bar-flex">
          <NavLink
            to="/captain-profile"
            exact
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/my-favorites"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Favorites
          </NavLink>   
          <NavLink
            to="/following"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Following
          </NavLink>
          <NavLink
            to="/followers"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Followers
          </NavLink>
          <NavLink
            to="/message"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Messages
            {summary.unreadMessagesCount > 0 &&
              <Label color='red' floating circular size='mini' style={{ top: '0.5em', right: '-1.5em' }}>{summary.unreadMessagesCount}</Label>}
          </NavLink>                              
          <NavLink
            to="/boats"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            My Boats
          </NavLink>
          <NavLink
            to="/my-products"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            My Products
            {summary.newSalesCount > 0 && 
              <Label color='red' floating circular size='mini' style={{ top: '0.5em', right: '-1.5em' }}>{summary.newSalesCount}</Label>}            
          </NavLink>                           
          <NavLink
            to="/profile/edit"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Profile
          </NavLink>
          {/* <NavLink
            to="/products"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Marketplace
          </NavLink>                     */}
          <NavLink
            to="/my-purchases"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Purchases
          </NavLink>  
          <NavLink
            to="/my-reservations"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Reservations
          </NavLink>                           
          <NavLink
            to="/settings"
            className="profileNav-bar-dashboard"
            activeStyle={activeLinkStyle}
          >
            Settings
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default ProfileNav;
